import { Link } from 'react-router-dom';
import { categoryList, siteInfo } from '@/mocks/news';

const quickLinks = [
  { label: '今日新瓜', to: '/#feed' },
  { label: '实时热榜', to: '/#rank' },
  { label: '专题分类', to: '/topics' },
  { label: '常见问题', to: '/#faq' },
  { label: '关于我们', to: '/about' },
  { label: '投稿联系', to: '/about#submit' },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-20 bg-primary-950 text-foreground-900">
      <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-lg" />
              </span>
              <span className="font-heading text-xl tracking-wide text-foreground-950">
                {siteInfo.name}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              {siteInfo.slogan}。把最新的动态按时间与热度排好，打开首页就能看懂来龙去脉。
            </p>
            <p className="mt-4 flex items-center gap-2 text-xs text-foreground-600">
              <i className="ri-radar-line" />
              {siteInfo.updateNote}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-label tracking-wide text-foreground-950">快捷导航</h4>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-foreground-700 transition-colors hover:text-primary-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-label tracking-wide text-foreground-950">内容圈子</h4>
            <ul className="mt-4 grid grid-cols-2 gap-2.5">
              {categoryList
                .filter((c) => c.id !== 'all')
                .map((c) => (
                  <li key={c.id}>
                    <Link
                      to={`/?cat=${c.id}#feed`}
                      className="text-sm text-foreground-700 transition-colors hover:text-primary-300"
                    >
                      {c.name}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-label tracking-wide text-foreground-950">联系与投稿</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-700">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-300" />
                {siteInfo.email}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-300" />
                {siteInfo.workTime}
              </li>
            </ul>
            <Link
              to="/about#submit"
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-label text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-send-plane-fill" />
              在线投稿
            </Link>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-primary-800/70 pt-6 text-xs text-foreground-600 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {siteInfo.name} · 本站内容为公开信息整理，不构成任何事实认定。</p>
          <p className="flex flex-wrap items-center gap-4">
            <span>内容原则：核实优先 · 标注信息状态</span>
            <span>图片均为抽象配图</span>
          </p>
        </div>
      </div>
    </footer>
  );
}